<template>
  <b-row class="match-height">
    <b-col cols="12">
      <b-card :title="this.$route.meta.title">
        <b-alert
          v-height-fade
          dismissible
          v-model="showDismissibleAlert"
          fade
          class="mb-2"
          variant="danger"
          v-id="showDismissibleAlert == true"
        >
          <div class="alert-body">
            <span>{{ messages }}</span>
          </div>
        </b-alert>
        <ValidationObserver v-slot="{ handleSubmit }">
          <b-form @submit.prevent="handleSubmit(save)">
            <b-row>
              <b-col md="6">
                <ValidationProvider
                  name="Nama"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-form-group label="Nama" label-for="mc-name">
                    <b-form-input
                      id="mc-name"
                      placeholder="Masukkan Nama"
                      v-model="model.name"
                    />

                    <p class="fs-6 text-danger">
                      {{ errors[0] }}
                    </p>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col md="6">
                <ValidationProvider
                  name="Link"
                  :rules="'required'"
                  v-slot="{ errors }"
                >
                  <b-form-group label="Link" label-for="mc-name">
                    <b-form-input
                      id="mc-name"
                      placeholder="Masukkan URL/Link"
                      v-model="model.link"
                      @change="checkUrl(model.link)"
                    />

                    <p class="fs-6 text-danger">
                      {{ errors[0] }}
                    </p>

                    <p v-if="error_link == false" class="fs-6 text-danger">
                      Incorect The Link format
                    </p>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col md="6">
                <ValidationProvider
                  name="Logo"
                  :rules="
                    $route.meta.action == 'store' ? 'required|image' : 'image'
                  "
                  v-slot="{ errors }"
                >
                  <b-form-group label="Logo" label-for="mc-logo">
                    <b-form-file
                      v-model="logos"
                      @change="logo_change"
                      placeholder="Choose a file"
                      drop-placeholder="Choose a file"
                      accept="image/x-png,image/jpeg"
                    />
                    <div class="clearfix" v-if="logo_prev != null">
                      <b-img
                        left
                        rounded
                        class="mb-1 mt-1"
                        height="120"
                        :src="logo_prev"
                      />
                    </div>
                    <p class="fs-6 text-danger">
                      {{ errors[0] }}
                    </p>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              <b-col md="6">
                <ValidationProvider
                  name="Status"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <b-form-group label="Status" label-for="mc-status">
                    <b-form-radio-group
                      v-model="model.status"
                      :options="statusList"
                      class="mt-1"
                      value-field="value"
                      text-field="label"
                    />
                    <p class="fs-6 text-danger">
                      {{ errors[0] }}
                    </p>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
            </b-row>
            <b-card-footer>
              <!-- submit and reset -->
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1 float-right"
              >
                Simpan
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                class="mr-1 float-right"
                variant="outline-secondary"
                :to="{ name: 'partners' }"
              >
                Batal
              </b-button>
            </b-card-footer>
          </b-form>
        </ValidationObserver>
      </b-card>
    </b-col>
  </b-row>
</template>

<style>
.mx-datepicker {
  width: 100% !important;
}
</style>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormFile,
  BFormCheckbox,
  BForm,
  BButton,
  BCard,
  BCardFooter,
  BFormRadioGroup,
  BFormInvalidFeedback,
  BFormValidFeedback,
  BFormTextarea,
  BAlert,
  BImg,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import axios from "@axios";
import { heightFade } from "@core/directives/animations";

export default {
  components: {
    BCard,
    BCardFooter,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormCheckbox,
    BForm,
    BButton,
    BFormRadioGroup,
    vSelect,
    BFormInvalidFeedback,
    BFormValidFeedback,
    BFormTextarea,
    BAlert,
    BImg,
  },
  directives: {
    Ripple,
    "height-fade": heightFade,
  },
  data() {
    return {
      name: "UsersForm",
      errors: {},
      showDismissibleAlert: false,
      config: {
        api: "/partner",
        redirect: "partners",
      },
      model: {},
      logos: null,
      logo_prev: null,
      confirmPass: null,
      error_link: true,
      roles: [
        // {
        //   id: 1,
        //   name: "Super Admin",
        // },
      ],
      statusList: [
        {
          label: "Aktif",
          value: "active",
        },
        {
          label: "Tidak Aktif",
          value: "inactive",
        },
      ],
      messages: "",
    };
  },
  mounted() {
    let _ = this;
    _.getData();
  },
  methods: {
    checkUrl(str) {
      var res = str.match(
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
      );
      this.error_link = res !== null;
      console.log(res !== null);
    },
    getData() {
      let _ = this;
      if (this.$route.meta.action == "edit") {
        axios
          .get(_.config.api + "/" + this.$route.params.id)
          .then((response) => {
            let _ = this;
            _.model = response.data.data;
            _.logo_prev = _.model.logo
              ? _.model.logo
              : "https://picsum.photos/1024/400/?image=41";
            // _.logo_prev = "https://picsum.photos/1024/400/?image=41"
          });
      }
    },
    logo_change(e) {
      const file = e.target.files[0];
      this.logo_prev = URL.createObjectURL(file);
      this.model.logo = file;
    },
    save() {
      let _ = this;
      if (this.$route.meta.action == "store") {
        let formData = new FormData();
        formData.append("name", _.model.name);
        formData.append("link", _.model.link);
        formData.append("status", _.model.status);
        formData.append("logo", _.model.logo);
        axios
          .post(_.config.api, formData)
          .then((res) => {
            _.$router.push({
              name: _.config.redirect,
              params: {
                event: "success",
                title: "Create Success",
                text: res.data.message,
              },
            });
          })
          .catch((e) => {
            // console.log(e.response.data.message.errors[0].msg);
            let vm = this;
            vm.showDismissibleAlert = true;
            if (typeof e.response.data.message === "object") {
              vm.messages = e.response.data.message.errors[0].msg;
            } else {
              vm.messages = e.response.data.message;
            }
          });
      } else {
        // let data = {
        //   name: _.model.name,
        //   link: _.model.link,
        //   status: _.model.status,
        //   logo: _.model.logo
        // };

        let formData = new FormData();
        if (this.logos) {
          formData.append("name", _.model.name);
          formData.append("link", _.model.link);
          formData.append("status", _.model.status);
          formData.append("logo", _.model.logo);
        } else {
          formData.append("name", _.model.name);
          formData.append("link", _.model.link);
          formData.append("status", _.model.status);
        }

        axios
          .put(_.config.api + "/" + _.$route.params.id, formData)
          .then((res) => {
            _.$router.push({
              name: _.config.redirect,
              params: {
                event: "success",
                title: "Update Supported By Success",
                text: res.data.message,
              },
            });
          })
          .catch((e) => {
            let vm = this;
            vm.showDismissibleAlert = true;
            if (typeof e.response.data.message === "object") {
              vm.messages = e.response.data.message.errors[0].msg;
            } else {
              vm.messages = e.response.data.message;
            }
          });
      }
    },
  },
};
</script>
